/* eslint-disable default-case */
/* eslint-disable no-case-declarations */
import React from 'react';
import { Typography, Box, IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import CustomToolbar from '../../components/common/CustomToolbar/CustomToolbar';
import _ from '../../utils/lodash';

const mapPropName = (columnName, isEntityToDto = false) => {
  const entityNames = ['Activity', 'CreatedBy', 'DateFrom', 'RecurrenceType', 'Assignments'];
  const dtoNames = ['activity', 'createdBy', 'dateRange', 'recurrence', 'assignedTo'];
  if (isEntityToDto) {
    const index = _.indexOf(entityNames, columnName);
    return dtoNames[index];
  }

  const index = _.indexOf(dtoNames, columnName);
  return entityNames[index];
};

const setSortDirection = (columnDtoName, options) => {
  const entityName = mapPropName(columnDtoName, false);

  return entityName === options.sortColumn ? options.sortDirection : 'none';
};

export const tableSettings = options => {
  const eventHandlers = options.eventHandlers;
  const locale = eventHandlers.locale;

  return {
    name: (
      <Box alignItems="center">
        <Typography variant="h3">{locale.getMsg('nonPatientActivities')}</Typography>
      </Box>
    ),
    columns: [
      {
        name: 'id',
        options: {
          display: 'excluded',
        },
      },
      {
        name: 'activity',
        label: locale.getMsg('activity'),
        options: {
          sort: true,
          sortOrder: {
            name: 'activity',
            direction: setSortDirection('activity', options),
          },
          setCellProps: () => ({ style: { width: '200px' } }),
        },
      },
      {
        name: 'assignedTo',
        label: locale.getMsg('assignedTo'),
        options: {
          sort: true,
          sortOrder: {
            name: 'assignedTo',
            direction: setSortDirection('assignedTo', options),
          },
          setCellProps: () => ({ style: { maxWidth: '500px' } }),
        },
      },
      {
        name: 'dateRange',
        label: 'From - To Date',
        options: {
          sort: true,
          sortOrder: {
            name: 'dateRange',
            direction: setSortDirection('dateRange', options),
          },
          setCellProps: () => ({ style: { width: '180px' } }),
        },
      },
      {
        name: 'timeRange',
        label: 'Start - End Time',
        options: {
          sort: false,
          setCellProps: () => ({ style: { width: '130px' } }),
        },
      },
      {
        name: 'duration',
        label: locale.getMsg('duration'),
        options: {
          sort: false,
          setCellProps: () => ({ style: { width: '100px' } }),
        },
      },
      {
        name: 'recurrence',
        label: locale.getMsg('recurrence'),
        options: {
          sort: true,
          sortOrder: {
            name: 'recurrence',
            direction: setSortDirection('recurrence', options),
          },
          setCellProps: () => ({ style: { width: '100px' } }),
        },
      },
      {
        name: 'createdBy',
        label: locale.getMsg('createdBy'),
        options: {
          sort: true,
          sortOrder: {
            name: 'createdBy',
            direction: setSortDirection('createdBy', options),
            setCellProps: () => ({ style: { width: '250px' } }),
          },
        },
      },
      {
        name: 'Actions',
        label: 'Actions',
        options: {
          sort: false,
          setCellHeaderProps: () => ({ className: 'centered' }),
          setCellProps: () => ({ style: { width: '100px' } }),
          customBodyRender: (value, tableMeta) => (
            <div>
              <IconButton
                onClick={() => options.eventHandlers.handleEdit(tableMeta.rowData[0], tableMeta.rowData[6])}
                disabled={options.currentItemId !== 0 && options.currentItemId === tableMeta.rowData[0]}
              >
                <EditIcon />
              </IconButton>
              |
              <IconButton
                onClick={() => options.eventHandlers.confirmDelete(tableMeta.rowData[0])}
                disabled={options.currentItemId !== 0 && options.currentItemId === tableMeta.rowData[0]}
              >
                <DeleteIcon />
              </IconButton>
            </div>
          ),
        },
      },
    ],
    options: {
      filterType: 'dropdown',
      responsive: 'standard',
      selectableRows: 'none',
      rowsPerPageOptions: [5, 15, 30, 50, 100],
      rowsPerPage: options.pageSize,
      search: false,
      filter: false,
      serverSide: true,
      count: options.count,
      page: options.page,
      customToolbar: () => (
        <CustomToolbar eventHandlers={options.eventHandlers} isTableDataLoading={options.isTableDataLoading} />
      ),
      onTableChange: (action, tableState) => {
        switch (action) {
          case 'changePage':
          case 'changeRowsPerPage':
            options.eventHandlers.updateTableProps(tableState.page + 1, tableState.rowsPerPage);
            break;
          case 'sort':
            let sortColumn = '';
            let sortDirection = '';

            if (tableState.activeColumn > -1) {
              sortColumn = mapPropName(tableState.sortOrder.name);
              sortDirection = tableState.sortOrder.direction;
              options.eventHandlers.updateTableSort(sortColumn, sortDirection);
            }
            break;
        }
      },
    },
  };
};
